import { createAction } from '@reduxjs/toolkit';

export const settingsStore = createAction('settings/store');
export const settingsClear = createAction('settings/clear');

export const settingsUpdateSensitiveContent = createAction('settings/updateSensitiveContent');

export const settingsUpdateCurrency = createAction('settings/updateCurrency');
// export const settingsUpdateCategory = createAction('settings/updateCategory');
export const settingsUpdateCurrencyCode = createAction('settings/updateCurrencyCode');
export const settingsUpdateStripeConnectPublic = createAction('settings/updateStripeConnectPublic');
export const settingsUpdateFacebookPixel = createAction('settings/updateFacebookPixel');
export const settingsUpdateTikTokPixel = createAction('settings/updateTikTokPixel');
export const settingsUpdateSpreadSheetTitle = createAction('settings/updateSpreadSheetTitle');
export const settingsUpdateSpreadSheetEmailTitle = createAction('settings/updateSpreadSheetEmailTitle');
export const settingsUpdateSpreadSheetFormTitle = createAction('settings/updateSpreadSheetFormTitle');
export const settingsUpdateIsAirtable = createAction('settings/updateIsAirtable');
export const settingsUpdateAirtableBaseId = createAction('settings/updateAirtableBaseId');
export const settingsUpdateAirtableShopTable = createAction('settings/updateAirtableShopTable');
export const settingsUpdateDirectMessagePreset = createAction('settings/updateDirectMessagePreset');
export const settingsUpdateIsAutoAction = createAction('settings/updateIsAutoAction');
export const settingsUpdatePaymentLink = createAction('settings/updatePaymentLink');
export const settingsUpdateWalletType = createAction('settings/updateWalletType');
export const settingsUpdateIsTelegram = createAction('settings/updateIsTelegram');
export const settingsUpdateIsShowingNotifsTelegram = createAction('settings/updateIsShowingNotifsTelegram');
export const settingsUpdateTelegramChatObj = createAction('settings/updateTelegramChatObj');
export const settingsUpdateDiscordUser = createAction('settings/updateDiscordUser');
export const settingsUpdateIsDiscordBotConnected = createAction('settings/updateIsDiscordBotConnected');
export const settingsUpdateSlackChannels = createAction('settings/updateSlackChannels');
export const settingsUpdateSlackNotifsChannelId = createAction('settings/updateSlackNotifsChannelId');
export const settingsUpdateIsShowingNotifsSlack = createAction('settings/updateIsShowingNotifsSlack');
export const settingsUpdateLangFields = createAction('settings/updateLangFields');

export const settingsUpdateIsWebhook = createAction('settings/updateIsWebhook');
export const settingsUpdateWebhookUrl = createAction('settings/updateWebhookUrl');
export const settingsUpdateIsWebhookLinkClick = createAction('settings/updateIsWebhookLinkClick');
export const settingsUpdateIsWebhookContactClick = createAction('settings/updateIsWebhookContactClick');
export const settingsUpdateIsWebhookCartAdd = createAction('settings/updateIsWebhookCartAdd');
export const settingsUpdateIsWebhookEmailSubmit = createAction('settings/updateIsWebhookEmailSubmit');
export const settingsUpdateIsWebhookFormSubmit = createAction('settings/updateIsWebhookFormSubmit');
export const settingsUpdateIsWebhookCartSubmit = createAction('settings/updateIsWebhookCartSubmit');
export const settingsUpdateIsWebhookAppointmentSubmit = createAction('settings/updateIsWebhookAppointmentSubmit');
export const settingsUpdateIsWebhookDigitalSubmit = createAction('settings/updateIsWebhookDigitalSubmit');
export const settingsUpdateIsWebhookDonationSubmit = createAction('settings/updateIsWebhookDonationSubmit');
export const settingsUpdateIsWebhookRequestSubmit = createAction('settings/updateIsWebhookRequestSubmit');
export const settingsUpdateWebhookEvents = createAction('settings/updateWebhookEvents');
export const settingsUpdateWebhookEvent = createAction('settings/updateWebhookEvent');

export const settingsUpdateIsUTM = createAction('settings/updateIsUTM');
export const settingsUpdateUTMMedium = createAction('settings/updateUTMMedium');
export const settingsUpdateUTMSource = createAction('settings/updateUTMSource');
export const settingsUpdateIsSEO = createAction('settings/updateIsSEO');
export const settingsUpdateSEOTitle = createAction('settings/updateSEOTitle');
export const settingsUpdateSEODescription = createAction('settings/updateSEODescription');
export const settingsUpdateSEOFavicon = createAction('settings/updateSEOFavicon');
export const settingsUpdateSEOImage = createAction('settings/updateSEOImage');
export const settingsUpdateSEOKeywords = createAction('settings/updateSEOKeywords');
export const settingsUpdateSitemap = createAction('settings/updateSitemap');
export const settingsUpdateRobots = createAction('settings/updateRobots');
export const settingsUpdateIsIndexable = createAction('settings/updateIsIndexable');

export const settingsUpdatePaymentMenuType = createAction('settings/updatePaymentMenuType');

export const settingsUpdateIsStripe = createAction('settings/updateIsStripe');
export const settingsUpdateIsPayPal = createAction('settings/updateIsPayPal');
export const settingsUpdateIsPayPalMe = createAction('settings/updateIsPayPalMe');
export const settingsUpdateIsWayForPay = createAction('settings/updateIsWayForPay');
export const settingsUpdateIsFondy = createAction('settings/updateIsFondy');
export const settingsUpdateIsCashActive = createAction('settings/updateIsCashActive');
export const settingsUpdateIsMonobank = createAction('settings/updateIsMonobank');

export const settingsUpdateFondyMerchantId = createAction('settings/fondyMerchantId');
export const settingsUpdateFondyPaymentKey = createAction('settings/fondyPaymentKey');
export const settingsUpdateWayforpayMerchantLogin = createAction('settings/wayforpayMerchantLogin');
export const settingsUpdateWayforpayMerchantSecretKey = createAction('settings/wayforpayMerchantSecretKey');
export const settingsUpdateMonobankToken = createAction('settings/monobankToken');
export const settingsUpdateMonobankConnect = createAction('settings/monobankConnect');
export const settingsUpdatePayPalClientID = createAction('settings/payPalClientID');
export const settingsUpdatePayPalClientSecret = createAction('settings/payPalClientSecret');
export const settingsUpdatePayPalAccountType = createAction('settings/payPalAccountType');
export const settingsUpdatePayPalMeLink = createAction('settings/payPalMeLink');
export const settingsUpdatePayPalConnect = createAction('settings/payPalConnect');
export const settingsUpdateGoogleAnalytics = createAction('settings/googleAnalytics');
export const settingsUpdateGoogleTag = createAction('settings/googleTag');
export const settingsUpdateIsCustomDomain = createAction('settings/isCustomDomain');
export const settingsUpdateCustomDomain = createAction('settings/customDomain');
export const settingsUpdateDomainStatus = createAction('settings/domainStatus');
export const settingsUpdateStripeConnect = createAction('settings/stripeConnect');

export const settingsUpdateIsMailchimp = createAction('settings/isMailchimp');
export const settingsUpdateIsGoogleSheet = createAction('settings/isGoogleSheet');
export const settingsUpdateReplyAPI = createAction('settings/replyAPI');
export const settingsUpdateSelzyAPI = createAction('settings/selzyAPI');
export const settingsUpdateKlaviyouAPI = createAction('settings/klaviyouAPI');
export const settingsUpdateSendPulseAPI = createAction('settings/sendPulseAPI');
export const settingsUpdateSendPulseUser = createAction('settings/sendPulseUser');
export const settingsUpdateSendPulseList = createAction('settings/sendPulseList');
export const settingsUpdateSendPulseEmailTitle = createAction('settings/sendPulseEmailTitle');
export const settingsUpdateSendPulseShopTitle = createAction('settings/sendPulseShopTitle');
export const settingsUpdateSendPulseFormTitle = createAction('settings/sendPulseFormTitle');

export const settingsUpdateWebhook = createAction('settings/webhook');

export const settingsUpdateIsShippingName = createAction('settings/isShippingName');
export const settingsUpdateIsShippingPhone = createAction('settings/isShippingPhone');
export const settingsUpdateIsShippingEmail = createAction('settings/isShippingEmail');
export const settingsUpdateIsShippingAddress = createAction('settings/isShippingAddress');
export const settingsUpdateIsShippingComment = createAction('settings/isShippingComment');
export const settingsUpdateIsShippingNameRequired = createAction('settings/isShippingNameRequired');
export const settingsUpdateIsShippingPhoneRequired = createAction('settings/isShippingPhoneRequired');
export const settingsUpdateIsShippingEmailRequired = createAction('settings/isShippingEmailRequired');
export const settingsUpdateIsShippingAddressRequired = createAction('settings/isShippingAddressRequired');
export const settingsUpdateIsShippingCommentRequired = createAction('settings/isShippingCommentRequired');
export const settingsUpdateShippingFields = createAction('settings/shippingFields');

export const settingsUpdateTimeZone = createAction('settings/timeZone');
export const settingsUpdatePinterestTag = createAction('settings/pinterestTag');
export const settingsUpdateHotjarId = createAction('settings/hotjarId');
export const settingsUpdateHeadTag = createAction('settings/headTag');
export const settingsUpdateBodyTag = createAction('settings/bodyTag');
export const settingsUpdateSiteLimit = createAction('settings/siteLimit');

export const settingsUpdatePropertiesList = createAction('settings/propertiesList');
export const settingsUpdateLists = createAction('settings/lists');
export const settingsUpdateLabels = createAction('settings/labels');
export const settingsUpdateCategories = createAction('settings/categories');

export const settingsUpdateIsSeoDefaultImage = createAction('settings/updateIsSeoDefaultImage');
export const settingsUpdateSeoDefaultImage = createAction('settings/updateSeoDefaultImage');
export const settingsUpdateInstagramBusinessUsers = createAction('settings/updateInstagramBusinessUsers');
export const settingsUpdatePreorderForm = createAction('settings/updatePreorderForm');

export const settingsUpdateAiAssistantNickname = createAction('settings/updateAiAssistantNickname');
export const settingsUpdateAiAssistantBio = createAction('settings/updateAiAssistantBio');
export const settingsUpdateAiAssistantOccupation = createAction('settings/updateAiAssistantOccupation');
export const settingsUpdateAiAssistantLocation = createAction('settings/updateAiAssistantLocation');
export const settingsUpdateAiAssistantInstructions = createAction('settings/updateAiAssistantInstructions');
export const settingsUpdateAiAssistantCategory = createAction('settings/updateAiAssistantCategory');
export const settingsUpdateAiAssistantLangCode = createAction('settings/updateAiAssistantLangCode');
